
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ConditionOperator from '../../common/common/ConditionOperator';

import { utils, ToolbarCommandButton } from '../../core';

const Condition = ({
    attr,
    operator,
    value,
    onDelete,
    onEdit
}) => {

    const getAttrValue = () => {
        let attrValue = value;
        if (attr.values) {
            attrValue = utils.processValueWithValues(attrValue, attr.values);
        }
        return attrValue;
    }

    const handleDelete = () => {
        if (onDelete) {
            onDelete(attr.id);
        }
    }

    const handleEdit = () => {
        if (onEdit) {
            onEdit(attr.id);
        }
    }

    return (
        <Stack horizontal verticalAlign="center" tokens={{childrenGap: 5}}>
            <FontIcon iconName="LocationDot" />
            <Stack.Item>{attr.title}</Stack.Item>
            <Stack.Item>{ConditionOperator.getConditionOperatorTitle(operator)}</Stack.Item>
            <Stack.Item grow>{getAttrValue()}</Stack.Item>
            <ToolbarCommandButton
                items={[{
                    title: 'Upravit podmínku pro vyhledávání',
                    icon: 'Edit',
                    onClick: handleEdit,
                    styles: {root: {height: 20}, icon: {padding: 0, margin: 0}}
                }, {
                    title: 'Odstranit podmínku pro vyhledávání',
                    icon: 'Delete',
                    onClick: handleDelete,
                    styles: {root: {height: 20}, icon: {padding: 0, margin: 0}}
                }]}
            />

        </Stack>
    );
}

const ConditionList = ({attrs, conditions, onDeleteCondition, onEditCondition}) => {

    const classNames = mergeStyleSets({
    });

    const getAttr = (name) => {
        return attrs.reduce((previous, current) => {
            return (current.id === name) ? current : previous;
        }, null);
    }

    const names = Object.keys(conditions).filter(item => !!conditions[item]);

    return (names.length > 0)
        ? (names.map(item => {
            return (
                <Stack.Item align="stretch" key={item}>
                    <Condition
                        attr={getAttr(item)}
                        operator={conditions[item].operator}
                        value={conditions[item].value}
                        onDelete={onDeleteCondition}
                        onEdit={onEditCondition}
                    />
                </Stack.Item>
            );
        }))
        : (
            <Stack.Item align="stretch">
                <Stack horizontal>
                    <FontIcon iconName="LocationDot" />
                    <Stack.Item>není zadaná žádná podmínka</Stack.Item>
                </Stack>
            </Stack.Item>
        );
}

export default ConditionList;
